<!--
  ~ Copyright (c) 2020 Signum+ Software & Facility GmbH
  ~ Author: jahn@signum-plus.at
  -->

<nav class="app-time-clock-shell-menu navbar navbar-dark bg-primary app-noselect">
  <div class="navbar-brand mb-0 h1">
    <span [kitText]="model.title.text"></span>
  </div>
  <div class="navbar-brand mb-0 h1">
    <span [kitValue]="model.time"></span>
  </div>
  <div class="navbar-brand mb-0 h1">
    <span [kitValue]="model.date"></span>
  </div>
</nav>
<div [kitContainer]="model.alertContainer" class="app-noselect"></div>
<div class="app-time-clock-shell-content app-noselect">
  <router-outlet></router-outlet>
</div>
<div class="app-time-clock-shell-footer app-noselect" [kitContainer]="model.footer">
</div>

